import { z } from 'zod';
import { MeetingTypes } from '@/features/caseCluster/caseCluster.types';
import { DEFAULT_HOST_VALUE } from '@/utils/constants/app.constants';

export const meetingInformationSchema = z.object({
  meetingType: z.nativeEnum(MeetingTypes),
  name: z.string().min(3),
  eventDate: z.date(),
  selectedClientID: z.string().optional(),
  meetingClientIDs: z.array(z.string()).min(1),
  location: z.string().min(3),
  caseClusterID: z.string().min(1),
});

export const meetingConfigurationSchema = z.object({
  selectedTeamID: z.string().optional(),
  meetingTeamIDs: z.array(z.string()).min(1),
  hostUserID: z.string().refine((data) => data !== DEFAULT_HOST_VALUE, {
    message: 'Host is required',
  }),
  hostFullName: z.string(),
  purchaseOrderNbr: z.string().optional(),
  customNotes: z.string().optional(),
  isStreamingHost: z.boolean(),
  isDemo: z.boolean(),
  generateGuestUrl: z.boolean(),
});

export const createMeetingFormSchema = meetingInformationSchema.merge(meetingConfigurationSchema);
export type CreateMeetingFormData = z.infer<typeof createMeetingFormSchema>;
